import classNames from 'classnames';
import {
  Icon,
  Button,
  ContentBlock,
  FlexContainer,
  Tabs,
  Txt,
  Spinner,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSearchMainStateHelpers } from '../../hooks';
import routes from '../SearchResults/routes';
import styles from './SearchToolbar.module.scss';

/**
 * SearchToolbar
 *
 * @return {JSX.Element}
 */
const SearchToolbar = ({ className }) => {
  const { state, handleSubmit, handleReset } = useSearchMainStateHelpers();

  const toggleFilterOpen = () => state.toggleFilter();

  const search = useLocation().search;
  const tabsOptions = useMemo(
    () =>
      routes.map((r) => ({
        ...r,
        path: search ? `${r.path}${search}` : r.path,
        key: r.path,
        value: r.title,
      })),
    [search]
  );

  return (
    <ContentBlock
      className={classNames(
        styles.SearchToolbar,
        className,
        `${SearchToolbar.displayName}`
      )}
      gap
      spaceBetween
      alignCenter
    >
      <FlexContainer flex>
        <Button onClick={toggleFilterOpen}>
          <Txt xx bold>
            <Icon name="filters" />
          </Txt>
          <Txt xx bold>
            Adjust Filters
          </Txt>
        </Button>
      </FlexContainer>
      <FlexContainer justifyContentEnd alignCenter gap>
        {state.searchResultsState.isLoading ? (
          <Spinner />
        ) : state.searchBrowserFilterState.isDirty ? (
          <Button onClick={handleReset}>Reset</Button>
        ) : null}
        {state.isFilterOpen ? (
          <Button onClick={handleSubmit} success>
            <Txt xx bold>
              Search
            </Txt>
          </Button>
        ) : (
          <Tabs options={tabsOptions} asNav buttons />
        )}
      </FlexContainer>
    </ContentBlock>
  );
};

SearchToolbar.displayName = 'SearchToolbar';

export default observer(SearchToolbar);
